/* eslint-disable @typescript-eslint/no-explicit-any */
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { BackendConfig } from '@elio/emanager-front/shared/app-config';
import { BACKEND_URL } from '@elio/shared/models';
import { AppModule } from './app/app.module';

fetch(`${BACKEND_URL}/test/info`)
  .then((response) => response.json())
  .then((config: BackendConfig) => {
    // Uggly, will be read in AppConfigService. This is the only way I found to dynamically load firebase config.
    (window as any).backendConfig = config;
    platformBrowserDynamic()
      .bootstrapModule(AppModule)
      .catch((err) => console.error(err));
  })
  .catch((error) => console.error('Error while retrieving firebase config.', error));
